import React from "react";
import { MdOutlineEmail } from "react-icons/md";
import { FiPhone } from "react-icons/fi";
import { FaWhatsapp } from "react-icons/fa";
import styles from "./Contact.module.css";

export default function Contact() {
  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.contact}>Contact Information</div>

        <div className={styles.topSection}>

          {/* Contact Card */}
          <div className={styles.address}>
            <h1 className={styles.h1}>Conference Coordinator</h1>
            <h3 className={styles.h3}>Dr. J. Uthayakumar</h3>

            <p className={styles.p}>
              Professor, Department of CSE <br />
              Idhaya Engineering College for Women <br />
              Nainarpalayam Road, Chinnasalem.
            </p>

            <div className={styles.info}>
              <div className={styles.contain}>
                <span>
                  <MdOutlineEmail />
                  <span className={styles.label}>Email</span>
                </span>
                <span className={styles.value}>icetmcp2026@gmail.com</span>
              </div>

              <div className={styles.contain}>
                <span>
                  <FiPhone />
                  <span className={styles.label}>Phone</span>
                </span>
                <span className={styles.value1}>+91 9677583754</span>
              </div>

              <div className={styles.contain}>
                <span>
                  <FaWhatsapp />
                  <span className={styles.label}>WhatsApp</span>
                </span>
                <span className={styles.value2}>+91 6374934589</span>
              </div>
            </div>
          </div>

          {/* Venue Section */}
          <div className={styles.venueAddress}>
            <h1>Venue Address</h1>
            <h3>Idhaya Engineering College for Women</h3>
            <p className={styles.para}>
              (Approved by AICTE, New Delhi 
              Affiliated to Anna University, Chennai) <br />
              (NAAC Accredited, ISO 9001:2015 Re-certified, 
              2(f) Status of UGC)
            </p>
            <p className="text-2xl">
              Nainarpalayam Road, Chinnasalem,
              <br />
              Kallakurichi - 606 201.
            </p>
          </div>

        </div>

        {/* Full Width Map */}
        <div className={styles.map}>
          <iframe
            title="Idhaya Engineering College"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3908.027399129999!2d78.88547437593499!3d11.621397088583475!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bab6ef94868a33f%3A0xe2f482a1cab1411a!2sIdhaya%20Engineering%20College!5e0!3m2!1sen!2sin!4v1767866923924!5m2!1sen!2sin"
            loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
          />

          <a
            href="https://maps.app.goo.gl/SXtcN2CKXYjfwU1F8"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.directionsButton}
          >
            Get Directions
          </a>
        </div>
      </div>
    </div>
  );
}